import { useEffect, useState } from 'react';

import getLastWeek from '../../utils/getLastWeek';

const Week = ({ selectedTime, setSelectedTime, resultSelectedSport }) => {
    const { lastWeek } = getLastWeek();
    const [weekList, setWeekList] = useState(
        lastWeek.map((day) => ({
            ...day,
            isSelected: day.date === lastWeek[0].date,
        })),
    );

    const selectDate = (date) => {
        setWeekList(
            weekList.map((day) => ({
                ...day,
                isSelected: day.date === date,
            })),
        );
    };

    const getResultByDate = (month, date) => {
        selectDate(date);
        setSelectedTime([month, date]);
    };

    useEffect(() => {
        getResultByDate(selectedTime[0] || lastWeek[0].month, selectedTime[1] || lastWeek[0].date);
    }, [resultSelectedSport]);

    return (
        <>
            {weekList.map(({
                month, date, day, isSelected,
            }) => (
                <div
                    key={day}
                    className="tab"
                    data-selected={isSelected}
                    onClick={() => getResultByDate(month, date)}
                >
                    <a className="btn">
                        <span className="text">{date}</span>
                        <span className="text text--small">{day}</span>
                    </a>
                </div>
            ))}
        </>
    );
};

export default Week;
